import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
import { colors } from "../../Theme";

interface PriorityFillProps {
  priority: "HIGH" | "MEDIUM" | "LOW";
}

const PriorityFill = (props: SVGProps<SVGSVGElement> & IconProps & PriorityFillProps) => {
  const fillColor = props.color
    ? props.color
    : props.priority === "HIGH"
      ? colors.oxygen600
      : props.priority === "MEDIUM"
        ? colors.oxygen400
        : colors.oxygen100;

  return (
    <svg
      width={props.size ? iconSizes[props.size] : "28px"}
      height={props.size ? iconSizes[props.size] : iconSizes["m"]}
      viewBox="0 0 28 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      title="PriorityFill"
      {...props}
    >
      <rect width="8" height="20" rx="2" fill={fillColor} />
      <rect
        x="10"
        width="8"
        height="20"
        rx="2"
        fill={props.priority === "LOW" ? colors.titanium200 : fillColor}
      />
      <rect
        x="20"
        width="8"
        height="20"
        rx="2"
        fill={
          props.priority === "LOW" || props.priority === "MEDIUM" ? colors.titanium200 : fillColor
        }
      />
    </svg>
  );
};
export default React.memo(PriorityFill);
